<template>
  <OwnPopover
    class="own-type-popover"
    :align-x="tooltipAlignX"
    :slide="tooltipAlignX === 'right' ? ['x'] : []"
    align-y="bottom"
    trigger-type="hover"
    content-offset="4"
    grow
  >
    <template #trigger="{ on }">
      <component
        :is="renderElement"
        class="own-type-popover__trigger w-full"
        :class="renderClass"
        :align="align"
        v-on="on"
        v-text="text"
      />
    </template>
    <template #content>
      <OwnCard class="own-type-popover__content" control>
        <OwnType :text="info" />
      </OwnCard>
    </template>
  </OwnPopover>
</template>

<script lang="ts" setup>
import { OwnCard } from '../OwnCard'
import { OwnPopover } from '../OwnPopover'

import OwnType from './OwnType.vue'

defineProps<{
  align: 'left' | 'center' | 'right'
  renderClass: string
  renderElement: string
  tabular: boolean
  tooltipAlignX: 'left' | 'right'
  text: string | number
  info: string
}>()
</script>

<style lang="scss" scoped>
.own-type-popover {
  &__trigger {
    cursor: help;
    text-decoration: underline;
    text-underline-offset: 4px;
    text-decoration-style: dotted;

    &.tabular-nums {
      font-variant-numeric: tabular-nums;
    }
  }

  &__content {
    padding: 12px;
    min-width: 250px;
  }
}
</style>
